import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a163e8e9ad5300142eb291/kdetaling/src/app/home-page/components/ContactSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a163e8e9ad5300142eb291/kdetaling/src/app/home-page/components/GallerySection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a163e8e9ad5300142eb291/kdetaling/src/app/home-page/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a163e8e9ad5300142eb291/kdetaling/src/app/home-page/components/NavBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a163e8e9ad5300142eb291/kdetaling/src/app/home-page/components/ServicesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a163e8e9ad5300142eb291/kdetaling/src/app/home-page/components/WhyUsSection.tsx");
